var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8078 9.94883C13.5177 9.94883 13.2828 10.1838 13.2828 10.4738V16.634L9.65438 13.896C9.42254 13.7215 9.09389 13.7675 8.91896 13.9989C8.74445 14.2305 8.79044 14.5596 9.02186 14.7343L13.4915 18.1071C13.5843 18.177 13.6958 18.213 13.8078 18.213C13.8876 18.213 13.9678 18.1947 14.0419 18.1577C14.2202 18.0689 14.3328 17.887 14.3328 17.688V10.4738C14.3328 10.1838 14.0978 9.94883 13.8078 9.94883ZM18.6627 3.25676C18.4704 3.04004 18.1384 3.0203 17.9217 3.21245L14.3328 6.3971V3.3122C14.3328 3.11312 14.2202 2.93126 14.0417 2.84243C13.8638 2.75381 13.6507 2.77313 13.4915 2.89325L7.7333 7.23836H5.06315C4.5581 7.23836 4.14734 7.64933 4.14734 8.15438V12.846C4.14734 13.3508 4.5581 13.7616 5.06315 13.7616H6.03314L2.38166 17.0023C2.16473 17.1949 2.14499 17.5267 2.33735 17.7434C2.44109 17.8604 2.58536 17.92 2.73026 17.92C2.85416 17.92 2.97869 17.8763 3.07844 17.7877L18.6184 3.99785C18.8354 3.80528 18.8551 3.47348 18.6627 3.25676ZM13.2828 7.32866L7.21649 12.7118H5.19734V8.28857H7.90928C8.02331 8.28857 8.1344 8.2514 8.22554 8.18252L13.2828 4.36619V7.32866Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMute);
export default __webpack_public_path__ + "static/media/mute.20c90c15ce3d6357039e2fb640b88034.svg";
export { ForwardRef as ReactComponent };